"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.qsOrThrowFit = void 0;
const qs_1 = require("./qs");
function qsOrThrowFit(selector, target) {
    const el = (0, qs_1.qs)(selector, target);
    if (!el)
        throw new Error(`Could not find element "${selector}"`);
    return el;
}
exports.qsOrThrowFit = qsOrThrowFit;
